<template>
  <div style="background-color: #f8f8f8;min-height: 100vh;padding:10px;">
    <Row style="margin-top:10px">
      <Col span="24">
        <Card :bordered="false"  dis-hover>
          <p slot="title">业绩统计规则设置</p>
          <Form :label-width="360">
            <FormItem  label="每发一封邮件停留时间（以毫秒为单位,1000毫秒=1秒）">
              <InputNumber v-model="form.space"></InputNumber>
            </FormItem>
            <FormItem >
              <Button type="primary" @click="save" >保存设置</Button>
            </FormItem>
          </Form>
        </Card>
      </Col>
    </Row>

  </div>
</template>

<script>
  export default {
    data(){
      return{
        power:0,
        uid:this.$storage.getSession('uid'),
        modal1:false,//新增
        form:{
          id:1,
          space:0,
        },
      }
    },
    methods:{
      load(){
        let that = this;
        this.$axios.get('/api/config/getById?id=1').then(function(rs){
          that.form = rs.data;
        });
      },
      save(){
        let that = this;
        this.$axios({url:'/api/config/update',method:"post",data:this.$qs.stringify(this.form)}).then(function(rs){
          that.toast(rs.data);
        })
      },
      toast(data){
        if(data>0){
          this.load();
          this.$Message.success('操作成功');
        }else{
          this.$Message.error('操作失败');
        }
      },

    },
    created(){
      this.load();
    }

  }
</script>



// WEBPACK FOOTER //
// src/components/config/Config.vue